import React from 'react';

class ScheduleFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.getClassName = this.getClassName.bind(this)
    this.handleChangeDesktop = this.handleChangeDesktop.bind(this)
    this.handleChangeMobile = this.handleChangeMobile.bind(this)
    this.close = this.close.bind(this)
    this.toggleState = this.toggleState.bind(this)
  }
  close(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.setState({ isOpen: false })
  }
  getClassName() {
    let open = this.state.isOpen ? " open" : ""
    return "schedule__filter__dt" + open
  }
  handleChangeDesktop(val) {
    this.props.handleFilterChange(val)
  }
  handleChangeMobile(event) {
    this.props.handleFilterChange(event.target.value)
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.close, false)
  }
  toggleState() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }))
    if (!this.state.isOpen) {
      document.addEventListener("click", this.close, false)
    } else {
      document.removeEventListener("click", this.close, false)
    }
  }

  render() {
    return (
      <div className="schedule__filter" onClick={this.toggleState} ref={node => this.node = node}>
        <div className={this.getClassName()} >
          {this.props.selectedOption ? this.props.selectedOption.name : this.props.emptyLabel}
          <ul className="select__options">
            <li className="select__option" onClick={() => this.handleChangeDesktop(null)}>{this.props.emptyLabel}</li>
            {this.props.options.map(option =>
              <li key={option.id} className="select__option" onClick={() => this.handleChangeDesktop(option.id)}>{option.name}</li>
            )}
          </ul>
        </div>
        <select className="schedule__filter__mob" value={this.props.selectedOption ? this.props.selectedOption.id : 0} onChange={this.handleChangeMobile}>
          <option value="0">{this.props.emptyLabel}</option>
          {this.props.options.map(option =>
            <option key={option.id} value={option.id}>{option.name}</option>
          )}
        </select>
      </div>
    )
  }
}

export default ScheduleFilter


// WEBPACK FOOTER //
// ./src/components/snippets/ScheduleFilter.jsx